import GoogleMapsLoader from "google-maps";
GoogleMapsLoader.KEY = "AIzaSyBt4h6NYlq1riPbxZ6XHC_FBDuCXwjOPrA";

export default {
  init() {
    // JavaScript to be fired on the about us page
    $(".attraction__gallery").slick({
      autoplay: true,
      infinite: true,
      autoplaySpeed: 2500,
      fade: true,
      lazyLoad: "ondemand",
      arrows: false,
      dots: false,
    });

    GoogleMapsLoader.load(function (google) {
      var mapMarker = {
        lat: parseFloat(window.php_vars.map_latitude),
        lng: parseFloat(window.php_vars.map_longitude),
      };

      var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 14,
        center: mapMarker,
      });

      var pin = new google.maps.Marker({
        // eslint-disable-line no-unused-vars
        position: mapMarker,
        map: map,
      });

      console.log(pin);
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/attraction.js